import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _TimeLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("circle", { cx: 12, cy: 12, r: 8.5, stroke: "currentColor" }), _jsx("path", { stroke: "currentColor", strokeLinecap: "round", d: "M16.5 12h-4.25a.25.25 0 0 1-.25-.25V8.5" })] }) });
}
const TimeLight = forwardRef(_TimeLight);
export { TimeLight };
